import { Language } from '../entities/language';
import { Population } from '../entities/population';

export abstract class PopulationRepository {
  abstract findAll(language: Language): Promise<readonly Population[]>;
}
